import { useState, useEffect, useCallback, useRef } from "react";
import { CommissionStatus } from "../../ContractCommissions/constants";

export function useGetUnassignedAgentContracts({
  api,
  payoutRunId,
  status = CommissionStatus.Approved,
  onError,
}) {
  const [contracts, setContracts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const apiRef = useRef(api);

  useEffect(() => {
    apiRef.current = api;
  }, [api]);

  const search = useCallback(
    async (term) => {
      const params = new URLSearchParams({ status });

      if (payoutRunId != null) {
        params.set("payoutRunId", payoutRunId);
      }

      if (term) {
        params.set("contractNumber", term);
      }

      setIsLoading(true);
      try {
        const response = await apiRef.current.get(
          `/api/commission/agent-contract?${params.toString()}`,
          { suppressGlobalError: true },
        );
        if (response.status === 200) {
          setContracts(response.data ?? []);
        }
      } catch (error) {
        onError?.(error);
      } finally {
        setIsLoading(false);
      }
    },
    [payoutRunId, status],
  );

  return { contracts, isLoading, search };
}
